<ion-content>
  <div class="wrapper">
    <div class="full content">
      <ng-container>
        <ion-router-outlet [animated]="false"></ion-router-outlet>
        <div class="lov center container front" [hidden]="false"></div>
      </ng-container>
    </div>

    <div class="sidebar-wrapper" [class.showApps]="showApps">
      <div class="sidebar">
        <div id="sidebar-container">
          <div id="logo-container">
            <div class="tooltip panelGrow">
              <ion-button
                class="apps-toggle"
                fill="clear"
                aria-label="Aplicativos"
                [class.active]="showApps"
                (click)="changeOverlay('apps')">
                <ion-icon aria-hidden="true" src="/assets/icon/jacto-logo-bold.svg"></ion-icon>
              </ion-button>
              <span class="tooltip-text" translate>common.apps</span>
            </div>

            <hr />
          </div>

          <div class="nav" *ngIf="module === 'network'">
            <div class="tooltip">
              <ion-button
                class="app m"
                routerLink="/panel/network/home"
                routerDirection="root"
                routerLinkActive="active"
                (click)="refreshAndChangeWebModule('home')"
                aria-label="Página inicial"
                fill="clear">
                <ion-icon slot="icon-only" aria-hidden="true" src="/assets/icon/home_icon.svg"> </ion-icon>
              </ion-button>
              <span class="tooltip-text" translate>panel.label.homePage </span>
            </div>

            <div class="tooltip">
              <ion-button
                class="app m"
                routerLink="/panel/network/news"
                routerDirection="root"
                routerLinkActive="active"
                (click)="refreshAndChangeWebModule('news')"
                aria-label="Notícias"
                fill="clear">
                <ion-icon slot="icon-only" aria-hidden="true" src="/assets/icon/news_icon.svg"> </ion-icon>
              </ion-button>
              <span class="tooltip-text" translate>common.news </span>
            </div>

            <div class="tooltip">
              <ion-button
                class="app m"
                routerLink="/panel/network/collaborators-list"
                routerDirection="root"
                routerLinkActive="active"
                (click)="refreshAndChangeWebModule('employee')"
                aria-label="Colaboradores"
                fill="clear">
                <ion-icon slot="icon-only" aria-hidden="true" src="/assets/icon/groups_icon.svg"> </ion-icon>
              </ion-button>
              <span class="tooltip-text" translate>common.employees </span>
            </div>
          </div>

          <div class="nav" *ngIf="module === 'payments'">
            <div *ngIf="!hideModuleReceipts && payslip" class="payments-subnav">
              <div class="tooltip" *ngFor="let app of paymentTabApps">
                <ion-button
                  class="app m statement-app"
                  [routerLink]="app.routerLink"
                  routerDirection="root"
                  routerLinkActive="active"
                  (click)="
                    refreshAndChangeReceiptsModule(app.routerParams); hideModuleReceipts = false; hideModuleWeb = true; module = 'payments'
                  "
                  fill="clear"
                  [attr.aria-label]="app.title | translate">
                  <ion-icon slot="icon-only" aria-hidden="true" [src]="app.sidebarIconSrc"></ion-icon>
                </ion-button>
                <span class="tooltip-text" translate>{{ app.title }}</span>
              </div>
            </div>

            <!-- <div *ngIf="!hideModuleReceipts && lineControl" class="tooltip">
							<ion-button
								class="app m"
								routerLink="/panel/payments/lineControl"
								routerDirection="root"
								routerLinkActive="active"
								(click)="refreshAndChangeReceiptsModule()"
								fill="clear"
							>
								<ion-icon slot="icon-only" name="call-outline"></ion-icon>
							</ion-button>
							<span class="tooltip-text" translate>panel.label.LineControl </span>
						</div> -->
          </div>

          <div class="nav" *ngIf="module === 'updates' && showEmployeeUpdate">
            <div class="nav-desktop-only">
              <div class="tooltip">
                <ion-button
                  class="app m"
                  routerLink="/panel/hrservices/employee-update-person-profile"
                  routerDirection="root"
                  routerLinkActive="active"
                  (click)="refreshAndChangeUpdatesModule('personProfile')"
                  fill="clear"
                  aria-label="Meu perfil">
                  <ion-icon src="../../assets/icon/account_circle.svg" aria-hidden="true" name="time-outline"></ion-icon>
                </ion-button>
                <span class="tooltip-text" translate>employeeUpdate.personProfile</span>
              </div>
              <div class="tooltip">
                <ion-button
                  class="app m"
                  routerDirection="root"
                  routerLinkActive="active"
                  (click)="gotoCornerstone('/phnx/driver.aspx?routename=Social/UniversalProfile/Resume')"
                  fill="clear"
                  aria-label="Curriculo">
                  <ion-icon src="../../assets/icon/article.svg" aria-hidden="true" name="time-outline"></ion-icon>
                </ion-button>
                <span class="tooltip-text" translate>employeeUpdate.curriculum</span>
              </div>
              <div class="tooltip">
                <ion-button
                  class="app m"
                  routerDirection="root"
                  routerLinkActive="active"
                  (click)="
                    gotoCornerstone(
                      '/phnx/driver.aspx?routename=Social/UniversalProfile/Transcript&TargetUser=1792&preSelectedCategoryId=3'
                    )
                  "
                  fill="clear">
                  <ion-icon src="../../assets/icon/school.svg" name="time-outline"></ion-icon>
                </ion-button>
                <span class="tooltip-text" translate>employeeUpdate.trainings</span>
              </div>
              <div class="tooltip">
                <ion-button
                  class="app m"
                  routerLink="/panel/hrservices/employee-update-members"
                  routerDirection="root"
                  routerLinkActive="active"
                  (click)="refreshAndChangeUpdatesModule('members')"
                  fill="clear">
                  <ion-icon src="../../assets/icon/family_restroom.svg" name="time-outline"></ion-icon>
                </ion-button>
                <span class="tooltip-text" translate>employeeUpdate.members</span>
              </div>
              <div class="tooltip">
                <ion-button
                  class="app m"
                  routerLink="/panel/hrservices/employee-update-health-plan"
                  routerDirection="root"
                  routerLinkActive="active"
                  (click)="refreshAndChangeUpdatesModule('healthPlan')"
                  fill="clear">
                  <ion-icon src="../../assets/icon/ecg_heart.svg" name="time-outline"></ion-icon>
                </ion-button>
                <span class="tooltip-text" translate>employeeUpdate.healthPlan</span>
              </div>
              <div class="tooltip">
                <ion-button
                  class="app m"
                  routerLink="/panel/hrservices/employee-update-life-insurance"
                  routerDirection="root"
                  routerLinkActive="active"
                  (click)="refreshAndChangeUpdatesModule('lifeInsurance')"
                  fill="clear">
                  <ion-icon src="../../assets/icon/health_and_safety.svg" name="time-outline"></ion-icon>
                </ion-button>
                <span class="tooltip-text" translate>employeeUpdate.lifeInsurance</span>
              </div>
              <div class="tooltip">
                <ion-button
                  class="app m"
                  routerLink="/panel/hrservices/employee-update-updates"
                  routerDirection="root"
                  routerLinkActive="active"
                  (click)="refreshAndChangeUpdatesModule('updates')"
                  fill="clear">
                  <ion-icon src="../../assets/icon/notifications_active.svg" name="time-outline"></ion-icon>
                </ion-button>
                <span class="tooltip-text" translate>employeeUpdate.updates</span>
              </div>
            </div>

            <div class="mobile-wrapper">
              <div class="expandable-menu" [class.is-expanded]="isMenuExpanded">
                <div class="apps-nav p">
                  <ng-container *ngFor="let app of updatesApps">
                    <ion-button
                      *ngIf="currentUpdatePage !== app.routerParams && app.routerParams !== 'address' && app.routerParams !== 'education'"
                      class="app m"
                      (click)="selectMobileOption(app.routerParams)"
                      fill="clear">
                      <ion-icon aria-hidden="true" [src]="app.iconNavSrc"></ion-icon>
                      <ion-label translate> {{ app.title }} </ion-label>
                    </ion-button>
                  </ng-container>
                </div>
              </div>

              <div class="mobile-bar">
                <ion-button
                  class="app m selected-option"
                  routerDirection="root"
                  routerLinkActive="active"
                  (click)="refreshAndChangeUpdatesModule(selectedUpdateIcon)"
                  fill="clear">
                  <ion-icon [src]="selectedUpdateIcon"></ion-icon>
                </ion-button>

                <ion-button (click)="toggleUpdatesMenu()" fill="clear">
                  <ion-icon src="../../assets/icon/add.svg" name="time-outline"></ion-icon>
                </ion-button>
              </div>
            </div>
          </div>
        </div>

        <div class="actions flex center nav max">
          <!-- <hr class="actions-divider" /> -->
          <div class="tooltip action-faq">
            <ion-button class="m-button" fill="clear" (click)="router.navigateByUrl('/faq')" aria-label="Perguntas frequentes">
              <ion-icon slot="icon-only" aria-hidden="true" src="/assets/icon/question_mark_icon.svg"> </ion-icon>
            </ion-button>
            <span class="tooltip-text" translate>panel.label.faq </span>
          </div>
          <div class="tooltip action-profile">
            <ion-button class="m-button" (click)="showModal()" fill="clear" aria-label="Meu perfil">
              <ion-icon slot="icon-only" aria-hidden="true" src="/assets/icon/person_icon.svg"> </ion-icon>
            </ion-button>
            <span class="tooltip-text" translate>panel.label.profile </span>
          </div>
          <div class="tooltip action-logout">
            <ion-button class="m-button" fill="clear" (click)="logout()" aria-label="Sair">
              <ion-icon slot="icon-only" aria-hidden="true" src="/assets/icon/logout_icon.svg"></ion-icon>
            </ion-button>
            <span class="tooltip-text" translate>panel.label.logout </span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="showApps" class="scroll">
        <div class="apps-overlay" (click)="changeOverlay('apps')"></div>
        <div class="apps lov lo1 phx scroll">
          <header class="header">
            <ion-icon
              *ngIf="updates"
              name="arrow-back-outline"
              class="hover back-icon"
              (click)="receipts = false; updates = false; showNormative = false"></ion-icon>
            <h1 class="h1-header">
              <span class="background-dark" translate *ngIf="!updates">common.apps</span>
              <span class="background-dark" translate *ngIf="updates">common.employeeUpdate</span>
            </h1>
            <ion-button *ngIf="!showAppsTools" (click)="changeOverlay('apps')" class="back" size="tiny" shape="round" fill="clear">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
            <ion-button *ngIf="showAppsTools" (click)="showAppsTools = false" class="back" size="tiny" shape="round" fill="clear">
              <ion-icon slot="icon-only" name="arrow-back-sharp"></ion-icon>
            </ion-button>
          </header>

          <div *ngIf="!showAppsTools && !receipts && !updates && !showNormative" class="apps-sections-container scroll">
            <!-- Destaques -->
            <section class="apps-section apps-section-favorites">
              <h2 class="apps-section-title" translate>menu.highlights</h2>
              <div class="apps-grid-2">
                <a
                  class="app-card"
                  routerLink="/panel/network/home"
                  routerDirection="root"
                  (click)="refreshAndChangeWebModule('home'); closeMenu(); module = 'network'">
                  <img src="/assets/icon/jacto-logo-bold.svg" class="app-card-icon" alt="Portal do Colaborador" />
                  <span translate>panel.apps.collaboratorPortal</span>
                </a>
                <a class="app-card" (click)="encryptAndRedirect(targetLinks.caminhosIntencionais)">
                  <img src="/assets/icon/ci2033.svg" class="app-card-icon" alt="Caminhos Intencionais 2033" />
                  <span translate>panel.apps.ci2033</span>
                </a>
              </div>
            </section>

            <!-- Área do Colaborador -->
            <section
              class="apps-section apps-section-collaborator-area"
              *ngIf="showServiceNow || showReceipts || showCornerstone || showOnTime || showEmployeeUpdate">
              <h2 class="apps-section-title" translate>menu.collaboratorArea</h2>
              <div class="apps-grid-3 apps-grid-scroll-mobile">
                <a
                  class="app-card"
                  *ngIf="showServiceNow && !isServiceNowMaintenance"
                  [href]="targetLinks.serviceNow.link"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src="/assets/icon/service-now.svg" class="app-card-icon" alt="CES" />
                  <span translate>panel.apps.serviceNow</span>
                </a>
                <a
                  class="app-card"
                  *ngIf="showServiceNow && isServiceNowMaintenance"
                  routerLink="/panel/maintenance/service-now"
                  routerDirection="root"
                  (click)="closeMenu()">
                  <img src="/assets/icon/service-now.svg" class="app-card-icon" alt="CES" />
                  <span translate>panel.apps.serviceNow</span>
                </a>
                <a class="app-card" *ngIf="showReceipts" (click)="refreshAndChangeReceiptsModule(); receipts = true">
                  <img src="/assets/icon/receipts-icon.svg" class="app-card-icon" alt="Meus extratos" />
                  <span translate>panel.apps.myExtracts</span>
                </a>
                <a class="app-card" *ngIf="showCornerstone" (click)="gotoCornerstone()">
                  <img src="/assets/icon/jacto-journey.svg" class="app-card-icon" alt="Carreira [+]" />
                  <span translate>panel.apps.jactoJourney</span>
                </a>
                <a class="app-card" *ngIf="showOnTime" [href]="targetLinks.onTime.link" target="_blank">
                  <img src="/assets/icon/ontime.svg" class="app-card-icon" alt="Gestão de ponto" />
                  <span translate>panel.apps.onTime</span>
                </a>
                <a class="app-card" *ngIf="showEmployeeUpdate" (click)="refreshAndChangeUpdatesModule(); updates = true">
                  <img src="/assets/icon/panel/person-icon.svg" class="app-card-icon" alt="Atualização cadastral" />
                  <span translate>common.employeeUpdate</span>
                </a>
              </div>
            </section>

            <!-- Serviços -->
            <section class="apps-section apps-section-services">
              <h2 class="apps-section-title" translate>menu.services</h2>
              <div class="apps-grid-3 apps-grid-scroll-mobile">
                <a class="app-card" href="https://serviceshub.grupojacto.com.br/" target="_blank">
                  <img src="/assets/icon/serviceshub.svg" class="app-card-icon" alt="Serviços de TI" />
                  <span translate>panel.apps.servicesSupport</span>
                </a>
                <a
                  class="app-card"
                  *ngIf="hasEmail"
                  href="https://apps.powerapps.com/play/e/Default-601e8490-2dc3-4737-a4da-60bbde5f1f61/a/aa051705-2152-4ccb-b961-781de995ffb9?source=iframe&hidenavbar=true"
                  target="_blank">
                  <img src="/assets/icon/spotCar.svg" class="app-card-icon" alt="Reserva de veículos" />
                  <span translate>panel.apps.spotCar</span>
                </a>
                <a
                  class="app-card"
                  *ngIf="hasEmail"
                  href="https://apps.powerapps.com/play/e/default-601e8490-2dc3-4737-a4da-60bbde5f1f61/a/feaba906-7bcf-4057-a32d-9bb62b0c44b7?tenantId=601e8490-2dc3-4737-a4da-60bbde5f1f61&source=curatedApps&hint=b0c9d85d-c70d-4db2-a1c0-2abf9f844c02&sourcetime=1711536326885"
                  target="_blank">
                  <img src="/assets/icon/permanentAssets.svg" class="app-card-icon" alt="Ativos imobilizados" />
                  <span translate>panel.apps.permanentAssets</span>
                </a>
                <a class="app-card" href="https://www.argoit.com.br/grupojacto" target="_blank">
                  <img src="/assets/icon/travel-management.svg" class="app-card-icon" alt="Gestão de viagens" />
                  <span translate>panel.apps.travelManagement</span>
                </a>
                <a
                  class="app-card"
                  *ngIf="hasEmail"
                  href="https://apps.powerapps.com/play/e/default-601e8490-2dc3-4737-a4da-60bbde5f1f61/a/e66cde25-ec6f-417f-9654-2e15f2173c3f?tenantId=601e8490-2dc3-4737-a4da-60bbde5f1f61&hint=ba511f9d-5afe-4817-bf7b-81b0141890f9&source=sharebutton&sourcetime=1716038148664"
                  target="_blank">
                  <img src="/assets/icon/icon_legalApp_new.svg" class="app-card-icon" alt="Serviços jurídicos" />
                  <span translate>panel.apps.legalApp</span>
                </a>
                <a class="app-card" *ngIf="showTermManagement" (click)="encryptAndRedirect(targetLinks.termsManagement)">
                  <img src="/assets/icon/termo-responsabilidade-ti.svg" class="app-card-icon" alt="Gestão de termos TI" />
                  <span translate>panel.apps.termoTI</span>
                </a>
              </div>
            </section>

            <!-- Ferramentas -->
            <section
              class="apps-section apps-section-tools"
              *ngIf="showIaAgent || showObservatory || showRecruitmentSelection || showPortalUnipac || showPSuggestion">
              <h2 class="apps-section-title" translate>menu.tools</h2>
              <div class="apps-grid-3 apps-grid-scroll-mobile">
                <a class="app-card" *ngIf="showIaAgent" (click)="encryptAndRedirect(targetLinks.iaAgent)">
                  <img src="/assets/icon/ia-agent.svg" class="app-card-icon" alt="GPT IA Agent" />
                  <span translate>panel.apps.iaAgent</span>
                </a>
                <a class="app-card" *ngIf="showObservatory" (click)="encryptAndRedirect(targetLinks.observatory)">
                  <img src="/assets/icon/technological-observatory.svg" class="app-card-icon" alt="Observatório Tecnológico" />
                  <span translate>panel.apps.observatory</span>
                </a>
                <a class="app-card" *ngIf="showRecruitmentSelection" (click)="encryptAndRedirect(targetLinks.recruitmentSelection)">
                  <img src="/assets/icon/recruitment-and-selection.svg" class="app-card-icon" alt="Recrutamento e Seleção" />
                  <span translate>panel.apps.recruitmentSelection</span>
                </a>
                <a class="app-card" *ngIf="showPortalUnipac" (click)="encryptAndRedirect(targetLinks.portalUnipac)">
                  <img src="/assets/icon/portal-unipac-bold.svg" class="app-card-icon" alt="Unipac Workspace" />
                  <span translate>panel.apps.portalUnipac</span>
                </a>
                <a class="app-card" *ngIf="showPSuggestion" (click)="encryptAndRedirect(targetLinks.programSuggestion)">
                  <img src="/assets/icon/program-suggestion.svg" class="app-card-icon" alt="Programa de Sugestões" />
                  <span translate>panel.apps.programSuggestion</span>
                </a>
              </div>
            </section>

            <!-- Informativos -->
            <section class="apps-section apps-section-informative">
              <h2 class="apps-section-title" translate>menu.informative</h2>
              <div class="apps-grid-3 apps-grid-scroll-mobile">
                <a class="app-card" href="https://compliance.grupojacto.com.br/" target="_blank">
                  <img src="/assets/icon/compliance.svg" class="app-card-icon" alt="Compliance" />
                  <span translate>panel.apps.compliance</span>
                </a>
                <a class="app-card" (click)="showNormative = true">
                  <img src="/assets/icon/normativos.svg" class="app-card-icon" alt="Normativos" />
                  <span translate>panel.apps.normativo</span>
                </a>
                <a class="app-card" *ngIf="hasEmail" href="https://jacto.sharepoint.com/sites/GRPDAFC_Programa_OEA" target="_blank">
                  <img src="/assets/icon/oea.svg" class="app-card-icon" alt="Portal OEA" />
                  <span translate>panel.apps.oeaPortal</span>
                </a>
                <a class="app-card" *ngIf="hasEmail" href="https://jacto.sharepoint.com/sites/InnovaTech" target="_blank">
                  <img src="/assets/icon/icon_innova_tech.svg" class="app-card-icon" alt="Innova Tech" />
                  <span translate>panel.apps.innovaTech</span>
                </a>
              </div>
            </section>
          </div>

          <div *ngIf="receipts" class="submenu-content">
            <div class="submenu-title-row">
              <button
                type="button"
                class="submenu-back-btn"
                (click)="receipts = false; updates = false; showNormative = false"
                aria-label="Voltar">
                <ion-icon name="arrow-back-outline"></ion-icon>
              </button>
              <h2 class="submenu-title" translate>panel.apps.myExtracts</h2>
            </div>

            <div class="submenu-grid submenu-grid-receipts">
              <a
                class="app-card submenu-card"
                *ngFor="let app of receiptsApps"
                [routerLink]="app.routerLink"
                routerDirection="root"
                routerLinkActive="active"
                (click)="!app.hidden && refreshAndChangeReceiptsModule(app.routerParams); closeMenu(); module = 'payments'"
                [style.display]="app.hidden ? 'none' : 'flex'">
                <img [src]="app.menuIconSrc" class="app-card-icon" />
                <span translate>{{ app.title }}</span>
              </a>
            </div>
          </div>
          <div *ngIf="updates && showEmployeeUpdate" class="lo1 loh wrap h-sa mvx">
            <a class="app" *ngFor="let app of updatesApps">
              <div class="sub-apps" *ngIf="!app.hidden">
                <a
                  class="app"
                  routerDirection="root"
                  [routerLink]="app.routerLink"
                  routerLinkActive="active"
                  (click)="refreshAndChangeUpdatesModule(app.routerParams); closeMenu(); module = 'updates'"
                  fill="clear">
                  <img [src]="app.iconSrc" class="icon-panel" />
                  <div class="tc" translate>{{ app.title }}</div>
                </a>
              </div>
            </a>
          </div>

          <div *ngIf="showNormative" class="submenu-content">
            <div class="submenu-title-row">
              <button
                type="button"
                class="submenu-back-btn"
                (click)="receipts = false; updates = false; showNormative = false"
                aria-label="Voltar">
                <ion-icon name="arrow-back-outline"></ion-icon>
              </button>
              <h2 class="submenu-title" translate>panel.apps.normativo</h2>
            </div>

            <div class="submenu-grid submenu-grid-normative">
              <a class="app-card submenu-card" href="https://jacto.sharepoint.com/sites/GRPDOHAC_Normativos_Corporativos2" target="_blank">
                <img src="/assets/icon/normativos.svg" class="app-card-icon" />
                <span translate>panel.apps.normativo.portal</span>
              </a>

              <a
                class="app-card submenu-card"
                routerDirection="root"
                routerLink="/panel/normative"
                routerLinkActive="active"
                (click)="closeMenu(); module = 'network'">
                <img src="/assets/icon/documents.svg" class="app-card-icon" />
                <span translate>panel.apps.normativo.public</span>
              </a>
            </div>
          </div>

          <div class="footer-sidebar">
            <hr />
            <div class="jacto-logo pv cursor-default">
              <img alt="Grupo Jacto" src="../../assets/icon/grupo-jacto-logo-black.svg" />
              <ion-label class="cursor-default background-dark">{{ appVersion }}</ion-label>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="showSettings">
        <div class="apps-overlay" (click)="changeOverlay('settings')"></div>
        <div class="apps lov lo1 phx">
          <header class="header">
            <h1 class="h1-header">
              <span class="background-white" translate>panel.label.config</span>
            </h1>
            <ion-button (click)="changeOverlay('settings')" class="back" size="tiny" shape="round" fill="clear">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
          </header>

          <hr class="m" />

          <div class="lo1 lov wrap ps mvx">
            <ion-row>
              <div class="configs-language" translate>panel.label.config.language</div>
            </ion-row>
          </div>

          <hr />

          <div class="jacto-logo pv cursor-default">
            <img alt="Grupo Jacto" src="../../assets/icon/grupo-jacto-logo-black.svg" />
            <ion-label class="cursor-default">{{ appVersion }}</ion-label>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ion-content>
